import { useState } from 'react';
import api from '../../../api/client';

export default function ExplainPage() {
  const [userId,  setUserId]  = useState('');
  const [queried, setQueried] = useState(null);
  const [access,  setAccess]  = useState(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  async function handleExplain(e) {
    e.preventDefault();
    if (!userId.trim()) return;
    setLoading(true);
    setError(null);
    setAccess(null);
    try {
      const { data } = await api.get('/security-policies/effective', { params: { user_id: userId.trim() } });
      setAccess(data.data?.access || null);
      setQueried(userId.trim());
    } catch (e) {
      setError(e.response?.data?.message || e.message);
      setQueried(userId.trim());
    } finally {
      setLoading(false);
    }
  }

  return (
    <div data-testid="security-explain-page" data-loading={loading ? 'true' : 'false'}>
      <h2>Effective Access</h2>
      <p>Enter a user id to see their core permissions plus any additive policy grants.</p>

      <form onSubmit={handleExplain} style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        <input
          placeholder="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          data-testid="secpol-explain-input"
          style={{ minWidth: 320 }}
          required
        />
        <button type="submit" data-testid="secpol-explain-submit" disabled={loading}>
          {loading ? 'Explaining...' : 'Explain'}
        </button>
      </form>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {access && queried && (
        <div data-testid={`secpol-explain-${queried}`} style={{ border: '1px solid #ccc', borderRadius: 8, padding: '1rem' }}>
          <div style={{ marginBottom: '0.75rem', color: '#666', fontSize: '0.9rem' }}>
            User <code>{access.userId}</code>
            {access.roles && access.roles.length > 0 && <> · roles: {access.roles.join(', ')}</>}
          </div>

          <h4 style={{ marginBottom: '0.25rem' }}>Core Permissions</h4>
          {(access.corePermissions && access.corePermissions.length > 0) ? (
            <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
              {access.corePermissions.map((p, i) => (
                <li key={i} data-testid="secpol-core-permission"><code>{p}</code></li>
              ))}
            </ul>
          ) : (
            <p>No core permissions.</p>
          )}

          <h4 style={{ marginBottom: '0.25rem', marginTop: '1rem' }}>Policy Grants</h4>
          {(access.policyGrants && access.policyGrants.length > 0) ? (
            <table style={{ width: '100%' }}>
              <thead>
                <tr><th>Policy</th><th>Domain</th><th>Principal</th><th>Actions</th><th>Constraint</th></tr>
              </thead>
              <tbody>
                {access.policyGrants.map((g, i) => (
                  <tr key={g.policyId || i} data-testid="secpol-policy-grant">
                    <td>{g.policyName}</td>
                    <td>{g.domain}</td>
                    <td>{g.principalType}: {g.principalRef}</td>
                    <td>{g.access?.actions ? g.access.actions.join(', ') : '—'}</td>
                    <td>{g.constraint ? <code>{JSON.stringify(g.constraint)}</code> : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No policy grants apply to this user.</p>
          )}

          {access.note && <p style={{ marginTop: '0.75rem', color: '#666', fontSize: '0.85rem' }}>{access.note}</p>}
        </div>
      )}
    </div>
  );
}
